import { createStore, createLogger } from 'vuex';
import state from './state';
import actions from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

import album from './modules/album';
import artist from './modules/artist';
import auth from './modules/auth';
import job from './modules/job';
import modal from './modules/modal';
import notification from './modules/notification';
import partyRoom from './modules/partyRoom';
import patchNote from './modules/patchNote';
import referral from './modules/referral';
import scene from './modules/scene';
import socketManager from './modules/socketManager';
import soundboard from './modules/soundboard';
import stripe from './modules/stripe';
import subscriptionPackage from './modules/subscriptionPackage';
import supportTicket from './modules/supportTicket';
import track from './modules/track';
import user from './modules/user';

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
    state,
    getters,
    actions,
    mutations,
    modules: {
        album,
        artist,
        auth,
        job,
        modal,
        notification,
        partyRoom,
        patchNote,
        referral,
        scene,
        socketManager,
        soundboard,
        stripe,
        subscriptionPackage,
        supportTicket,
        track,
        user,
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
});
